import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import { useAuth } from '../composables/useAuth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: HomeView,
    },
    {
      path: '/sign-in',
      component: () => import('../views/SignInView.vue'),
      beforeEnter: () => {
        const { isAuthenticated, user } = useAuth();
        if (isAuthenticated.value) {
          return user.value?.email?.endsWith('@ridgecodetech.com') ? '/admin' : '/dashboard';
        }
      },
    },
    {
      path: '/dashboard',
      component: () => import('../views/DashboardView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/support',
      component: () => import('../views/SupportView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin',
      component: () => import('../views/AdminView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/client/:id',
      component: () => import('../views/AdminClientView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/intern/:id',
      component: () => import('../views/AdminInternView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/ai/:id',
      component: () => import('../views/AdminAiView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/consulting/:id',
      component: () => import('../views/AdminConsultingView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/custom/:id',
      component: () => import('../views/AdminCustomView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/onboarding',
      component: () => import('../views/AdminOnboardingView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/intake',
      component: () => import('../views/IntakeView.vue'),
    },
    {
      path: '/survey/:token',
      component: () => import('../views/SurveyView.vue'),
    },
  ],
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const { isAuthenticated, user } = useAuth();
  const isAdmin = user.value?.email?.endsWith('@ridgecodetech.com') ?? false;

  if (to.meta.requiresAuth && !isAuthenticated.value) return '/sign-in';
  if (to.path === '/dashboard' && isAuthenticated.value && isAdmin) return '/admin';
  if (to.meta.requiresAdmin) {
    if (!isAuthenticated.value) return '/sign-in';
    if (!isAdmin) return '/dashboard';
  }
});

export default router;
